export default class ConfigManager {
  getApiEndpoint = () => {
    return process.env.REACT_APP_API_ENDPOINT?.trim() as string;
  };

  getReactOauthRedirect = () => {
    return process.env.REACT_APP_REDIRECT_URL as string;
  };

  getDefaultDateRangeMonths = (): number => {
    const value = parseInt(process.env.REACT_APP_DEFAULT_DATE_RANGE_MONTHS ?? '2', 10);
    return isNaN(value) || value < 1 ? 2 : value;
  };
}
